module.exports = "body {\n  overflow-x: hidden !important;\n  overflow-y: scroll; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fine-mercato-tutelato/fine-mercato-tutelato.component.scss
// module id = ./src/app/fine-mercato-tutelato/fine-mercato-tutelato.component.scss
// module chunks = main